var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "opt_container", style: _vm.layerStyle },
    [
      _c(
        "head-cont-layer",
        _vm._b({}, "head-cont-layer", _vm.propsMap.headCont, false)
      ),
      _vm._v(" "),
      _c(
        "list-num-layer",
        _vm._b({}, "list-num-layer", _vm.propsMap.listNum, false)
      ),
      _vm._v(" "),
      _c("move-layer", _vm._b({}, "move-layer", _vm.propsMap.move, false)),
      _vm._v(" "),
      _c("edit-layer", _vm._b({}, "edit-layer", _vm.propsMap.edit, false)),
      _vm._v(" "),
      _c("role-layer", _vm._b({}, "role-layer", _vm.propsMap.role, false)),
      _vm._v(" "),
      _c(
        "notice-layer",
        _vm._b({}, "notice-layer", _vm.propsMap.notice, false)
      ),
      _vm._v(" "),
      _c("user-layer", _vm._b({}, "user-layer", _vm.propsMap.user, false)),
      _vm._v(" "),
      _c(
        "folder-layer",
        _vm._b({}, "folder-layer", _vm.propsMap.folder, false)
      ),
      _vm._v(" "),
      _c("week-layer", _vm._b({}, "week-layer", _vm.propsMap.week, false)),
      _vm._v(" "),
      _c("mode-layer", _vm._b({}, "mode-layer", _vm.propsMap.mode, false))
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }